import { HeaderShownContext } from "@react-navigation/elements";
import React from "react";
import { Platform } from "react-native";
import {
  SafeAreaInsetsContext,
  useSafeAreaInsets,
} from "react-native-safe-area-context";

import { RealSafeAreaInsetsContext } from "@/hooks/useRealSafeAreaInsets";
import { Box, VStack } from "@whoosh/design-system/src/components/primitive";

export type PageWrapperProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
};

export const PageWrapper = ({ header, children }: PageWrapperProps) => {
  const insets = useSafeAreaInsets();
  const hasHeader = Boolean(header);
  return (
    <VStack flex={1} height="100%">
      {hasHeader ? (
        <Box
          testID="page-wrapper-header"
          style={{
            position: Platform.OS === "web" ? "static" : "relative",
            top: 0,
            paddingTop: insets.top,
          }}
          zIndex={10}
          backgroundColor="surface-primary"
          borderBottomWidth={{ base: 0, sm: 1 }}
          borderBottomColor={{ base: undefined, sm: "surface-dividers" }}
        >
          {header}
        </Box>
      ) : null}
      {/*
       * When a header is present it consumes the top safe area inset. We
       * signal this to React Navigation via HeaderShownContext (which tells
       * native-stack SceneView to set topInset=0 so no native content-inset
       * is applied) and also zero out the JS SafeAreaInsetsContext so that
       * any component using useSafeAreaInsets() doesn't double-add the offset.
       */}
      <HeaderShownContext.Provider value={hasHeader}>
        <RealSafeAreaInsetsContext.Provider value={insets}>
          <SafeAreaInsetsContext.Provider
            value={hasHeader ? { ...insets, top: 0 } : insets}
          >
            <Box testID="page-wrapper-content" flex={1}>
              {children}
            </Box>
          </SafeAreaInsetsContext.Provider>
        </RealSafeAreaInsetsContext.Provider>
      </HeaderShownContext.Provider>
    </VStack>
  );
};
